export default "__VITE_ASSET__MjeQfZIr__"